var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3748 18.625V22.25H28.9998V24.6667H25.3748V28.2917H22.9582V24.6667H19.3332V22.25H22.9582V18.625H25.3748ZM25.3845 4.125C26.0467 4.125 26.5832 4.66271 26.5832 5.32487V16.2083H24.1665V6.54167H4.83317V23.4571L16.9165 11.375L20.5415 15V18.4184L16.9165 14.7934L8.24913 23.4583H16.9165V25.875H3.61517C3.29715 25.8747 2.99227 25.7481 2.76751 25.5231C2.54275 25.2982 2.4165 24.9931 2.4165 24.6751V5.32487C2.41872 5.00754 2.54568 4.70381 2.76996 4.4793C2.99424 4.2548 3.29784 4.12753 3.61517 4.125H25.3845ZM9.6665 8.95833C10.3074 8.95833 10.9221 9.21295 11.3753 9.66616C11.8286 10.1194 12.0832 10.7341 12.0832 11.375C12.0832 12.0159 11.8286 12.6306 11.3753 13.0838C10.9221 13.5371 10.3074 13.7917 9.6665 13.7917C9.02556 13.7917 8.41088 13.5371 7.95766 13.0838C7.50445 12.6306 7.24984 12.0159 7.24984 11.375C7.24984 10.7341 7.50445 10.1194 7.95766 9.66616C8.41088 9.21295 9.02556 8.95833 9.6665 8.95833Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4963"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 29,
    height: 29,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageAdd);
export default __webpack_public_path__ + "static/media/image-add.50c5144364659fb6228d748c5beaa4ab.svg";
export { ForwardRef as ReactComponent };